import { SharedLOAInformation } from 'views/shared/LOAInformation';
import {
  changePolicyInformation,
  changeMethodOfPayment,
  removeMissingMandatoryField,
  addMissingMandatoryField,
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
} from 'reducers/autoPersonalFormReducer';
import { SECTIONS } from 'views/auto_form/constants';

const LOAInformation = () => {
  return (
    <SharedLOAInformation
      formStateKey="autoPersonalForm"
      formActions={{
        changePolicyInformation,
        changeMethodOfPayment,
        removeMissingMandatoryField,
        addMissingMandatoryField,
        addRemark,
        removeRemark,
        updateRemark,
        addFile,
        removeFile,
      }}
      sectionId={SECTIONS.POLICY_INFORMATION}
    />
  );
};

export default LOAInformation;
